<template>
  <div class="home">
    <el-carousel height="100vh">
      <el-carousel-item>
        <img src="@/assets/images/home/banner1.png" class="banner-img" alt="">
        <img src="@/assets/images/home/banner-mobile1.png" class="banner-mobile-img"  alt="">
        <div class="banner-text">
          <div class="title">工程结构安全检测&监测方案领跑者</div>
          <div class="info">集成智能传感与AI监测系统，为建筑/桥梁/隧道提供24小时毫米级精度监测，通过数据驱动预警决策，保障基础设施全生命周期安全。</div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <img src="@/assets/images/home/banner2.png" class="banner-img"   alt="">
        <img src="@/assets/images/home/banner-mobile2.png"  class="banner-mobile-img"  alt="">
        <div class="banner-text">
          <div class="sub-title">HURI虎锐</div>
          <div class="title">隧道无人巡检机器人</div>
          <div class="info">多功能无人巡检、拖曳、运输</div>
          <div class="link" @click="$router.push('/ExplorationVehicle')">了解更多 <i class="el-icon-arrow-right"></i></div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!--首页介绍-->
    <div class="model">
      <div class="model-left">
        <div class="model-title icon icon1">主营业务</div>
        <div class="model-info">
          主营业务覆盖地铁隧道、公路桥梁、矿山工程三大板块，形成以智能巡检装备为核心，集AI算法、智能检测、数据分析、三维建模于一体的全链条服务体系。公司拥有自主研发的隧道巡检机器人、无人机巡航检测系统、自动巡检机器人检测设备等智能硬件，配套开发了基于深度学习的病害识别算法、多源数据融合分析平台、三维实景建模系统等核心技术与平台，构建了"技术+装备+系统+服务"四位一体的检测监测解决方案，业务涵盖隧道结构健康监测、轨道病害智能诊断、道桥施工安全管控、矿井水文地质监测预警等领域，为城市轨道交通、高速公路、矿山开发等场景提供全生命周期数字化管理解决方案。
        </div>
      </div>
      <div class="model-right">  <img src="../assets/images/home/model1.png" alt=""/></div>
    </div>
    <div class="model">
      <div class="model-left">
        <div class="model-title  icon icon2">产品及解决方案</div>
        <div class="model-info">隧道智能巡检方案：隧道巡检机器人采用驱控一体、边端融合等技术，模块化设计便于维护。搭载红外热成像与激光测距仪，支持自主巡航与三模操控，借助几何检测、动态病害识别算法，自动检测衬砌缺陷、轨道异物、渗水等隐患。桥梁道路检测方案：基于无人机巡检与三维建模，融合 AI 图像识别和大数据分析，构建空 - 地协同体系，精准识别裂缝、剥落等病害，实现全生命周期数字化管理。矿山工程监测方案：利用物联网与 AI 技术，实时监测地下水水位、水压等关键参数，建立三维水文地质预警体系，可快速识别突水水源，实现矿山建设全周期智能管控。</div>
        <el-button plain @click="$router.push('/scheme')">
          查看详情 <img src="../assets/images/home/go.png" />
        </el-button>
      </div>
      <div class="model-right"> <img src="../assets/images/home/model2.png" alt=""/></div>
    </div>
    <div class="model">
      <div class="model-left">
        <div class="model-title icon icon3">应用案例</div>
        <div class="model-info">
          济南地铁1号线王府庄站进行了巡检设备轨道地板异物检测模块现场应用。
          青岛地铁3号线青岛北站进行了巡检装备远程操作及定位功能现场应用。
          瑞海金矿开展了水害监测（防海水溃入）系统、多源数据融合三维地质建模及动态分析系统、矿井水文动态监测预警软件平台等部分的工作。
        </div>
        <el-button plain @click="$router.push('/case')">
          查看详情<img src="../assets/images/home/go.png" />
        </el-button>
      </div>
      <div class="model-right">
        <el-carousel height="29vw" indicator-position="none" arrow="never">
          <el-carousel-item><img src="../assets/images/home/case1.png" alt=""/></el-carousel-item>
          <el-carousel-item><img src="../assets/images/home/case2.png" alt=""/></el-carousel-item>
          <el-carousel-item><img src="../assets/images/home/case3.png" alt=""/></el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!--公共底部-->
    <footerView></footerView>
  </div>
</template>

<script>
import footerView from "@/components/footerView.vue";
export default {
  name: 'HomeView',
  components:{
    footerView
  },
  mounted() {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  },
  data(){
    return {
      caseList:[
        {}
      ],
      active:0
    }
  }
}
</script>
<style scoped lang="scss">
.home{
  background: #131415
}
.banner-text{
  position: absolute;
  z-index: 10;
  color: #fff;
  .title{
    font-size: 52px;
  }
  .info{
    font-size: 16px;
    text-align: center;
    width: 100%;
    line-height: 32px;
    margin-top: 16px;
  }
  .sub-title{
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 12px;
  }
  .link{
    font-size: 16px;
    line-height: 32px;
    color: #92c0fc;
    cursor: pointer;
    margin-top: 24px;
    font-weight: 600;
  }
}
::v-deep .el-carousel__container{
  max-height: 56.25vw!important;
}
::v-deep .el-carousel__item{
  &:nth-of-type(1){
    .banner-text{
      left: 50%;
      top: 45%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      width: 1100px;
      max-width: 84%;
      .title{
        margin-bottom: 20px;
      }
    }
  }
  &:nth-of-type(2){
    .banner-text{
      left: 50%;
      top: 130px;
      transform: translateX(-50%);
      text-align: center;
      .info{
        text-align: center;
        width: 100%;
      }
    }
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.model{
  padding: 60px 20px;
  display: flex;
  align-items: center;
  min-height: 50vh;
  height: auto;
  .model-left{
    flex: 1;
    padding-right: 3vw;
    .model-title{
      font-weight: 600;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 32px;
      letter-spacing: 1px;
      margin-bottom: 30px;
      padding-left: 40px;
      &.icon1{
        background: url(../assets/images/home/icon1.png) no-repeat left center;
        background-size:  32px auto;
      }
      &.icon2{
        background: url(../assets/images/home/icon2.png) no-repeat left center;
        background-size:  32px auto;
      }
      &.icon3{
        background: url(../assets/images/home/icon3.png) no-repeat left center;
        background-size:  32px auto;
      }
    }
    .model-info{
      font-weight: 400;
      color: #FFFFFF;
      font-size: 14px;
      line-height: 2;
      opacity: .6;
      margin-bottom: 30px;
      text-align: justify;
    }
    .el-button{
      border: 1px solid rgba(255,255,255,.14);
      background: transparent;
      color: #3D91FF;
      padding: 8px 16px;
      font-size: 16px;
      border-radius: 4px;
      img{
        width: 42px;
        margin-left: 8px;
        transform: translateY(-3px);
      }
    }
  }
  .model-right{
    width: 45%;
    img{
      width: 100%;
      height: auto;
      max-height: 500px;
      object-fit: contain;
    }
  }
  &:nth-child(2n){
    background: url(../assets/images/home/model-bg.png) no-repeat center;
    background-size: cover;
  }
  &:nth-child(2n+1){
    background: #20242D;
  }
}

/* 平板设备适配 */
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .model{
    padding: 40px 15px;
    flex-direction: column;
    .model-left{
      padding-right: 0;
      margin-bottom: 30px;
    }
    .model-right{
      width: 100%;
    }
  }
}
@media screen and (max-width: 1440px){
  .banner-text {
    top: 130px;
    .info{
      font-size: 18px;
      line-height: 28px;
    }
    .link{
      font-size: 18px;
      line-height: 32px;
    }
  }
  .model .model-left .el-button{
    font-size: 18px;
  }
}
@media screen and (max-width: 768px){
  .home{
    .el-carousel{
      overflow: hidden;
      height: 125vw!important;
      max-height: unset;
      ::v-deep .el-carousel__container{
        height: 125vw!important;
        .el-carousel__item{
          height: 125vw!important;
          .banner-text{
            left: 0;
            top: 0;
            transform: translateY(0);
            width: 100%;
            text-align: center;
            padding: 120px 16px 0;
            box-sizing: border-box;
            max-width: 100%;
            .title{
              font-size: 20px;
              line-height: 32px;
            }
            .info{
              width: 100%;
              text-align: center;

            }
          }

        }
      }
    }
    .model{
      flex-direction: column-reverse;
      padding: 24px 16px;
      height: auto;
      max-height: unset;
      .model-left{
        padding: 0;
        .model-title{
          font-size: 20px;
          margin-bottom: 8px;
          margin-top: 12px;
          background-size: 24px auto;
          padding-left: 28px;
        }
        .model-info{
          font-size: 14px;
          line-height: 2;
          margin-bottom: 0;
        }
        button{
          margin-top: 16px;
          font-size: 14px;
        }
      }
      .model-right{
        width: 100%;
        ::v-deep .el-carousel{
          height: 57.5vw!important;
          overflow: hidden;
        }
      }
    }

  }

}

:v-deep .el-carousel__indicators--horizontal{
  bottom: 20px;
}

/* 超小屏幕移动端 (小于375px) - iPhone SE等小屏手机 */
@media screen and (max-width: 374px) {
  /* 样式规则 */
}

/* 小屏幕移动端 (375px-479px) - iPhone等标准手机 */
@media screen and (max-width: 479px) and (min-width: 375px) {
  /* 样式规则 */
}

/* 中屏幕移动端 (480px-768px) - 大屏手机 */
@media screen and (max-width: 768px) and (min-width: 480px) {
  /* 样式规则 */
}

/* 所有移动端 (小于768px) */
@media screen and (max-width: 767px) {
  /* 样式规则 */
  .banner-text .title{
    font-size: 32px;
    line-height: 44px;
  }
  .banner-img{
    width: 100%;
    height: auto;
    max-height: 500px;
    object-fit: contain;
  }
  .banner-mobile-img{
    display: none;
  }
  /* 样式规则 */
  .banner-img{
    display: none;
  }
  .banner-mobile-img{
    display: block;
  }
   .banner-text { 
    .title{
      font-size: 20px;
      line-height: 44px;
    }
    .info{
      line-height: 24px;
      margin-top: 0!important;
      font-size: 16px;
    }
    .sub-title{
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 0;
    }
    .link{
      margin-top: 2px;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
    }
  }
}

/* 小屏平板 (769px-1024px) - iPad Mini等 */
@media screen and (min-width: 769px) and (max-width: 1024px) {
  /* 样式规则 */
  .banner-text {
    .title{
        font-size: 22px;
        line-height: 24px;
      }  
      .info{
        font-size: 14px;
        line-height: 24px;
      }
      .sub-title{
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 0;
      }
  }
  .el-carousel__item:nth-of-type(2) .banner-text{
    padding: 8px  24px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    backdrop-filter: blur(6px);
    >div{
      margin: 0 auto;
      &.title{ 
        line-height: 40px;
      }
    }
  }
}

/* 大屏平板 (1025px-1199px) - iPad Pro等 */
@media screen and (max-width: 1199px) and (min-width: 1025px) {
  .model{
    min-height: 26vh;
  }
  .el-carousel__item img{
    height: 100%;
  }
  /* 样式规则 */ 
  .banner-text .title{
    font-size: 44px;
    line-height: 56px;
  }
  .el-carousel__item:nth-of-type(2) .banner-text{
    padding: 16px  24px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    backdrop-filter: blur(6px);
  }
}

/* 小屏幕PC (1200px-1399px) - 13-14寸笔记本 */
@media screen and (min-width: 1200px) and (max-width: 1399px) {
  /* 样式规则 */
  .banner-text .title{
    font-size: 48px;
    line-height: 64px;
  }
  .model{
    min-height: 26vh;
  }
  .el-carousel__item img{
    height: 100%;
  }
  .el-carousel__item:nth-of-type(2) .banner-text{
    padding: 16px  24px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    backdrop-filter: blur(6px);
  }
}

/* 中屏幕PC (1400px-1599px) - 15-16寸笔记本/小屏显示器 */
@media screen and (max-width: 1599px) and (min-width: 1400px) {
  /* 样式规则 */
   .el-carousel__item:nth-of-type(2) .banner-text{
    padding: 16px  24px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    backdrop-filter: blur(6px);
  }
}

/* 大屏幕PC (1600px-1919px) - 22-24寸显示器 */
@media screen and (max-width: 1919px) and (min-width: 1600px) {
  /* 样式规则 */
}

/* 超大屏幕PC (1920px及以上) - 27寸以上显示器 */
/* 大屏幕PC适配 (1920px及以上) */
@media screen and (min-width: 1920px) {
  :deep(.el-carousel .el-carousel__arrow) {
    width: 48px;
    height: 48px;
    > i {
      font-size: 20px;
    }
  }
}

/* 超高清屏幕 (2K及以上) */
@media screen and (min-width: 2560px) {
  :deep(.el-carousel .el-carousel__arrow) {
    width: 56px;
    height: 56px;
    > i {
      font-size: 24px;
    }
  }
  .model {
    padding: 120px 60px;
  }
  .banner-txt {
    .title {
      font-size: 36px !important;
      margin-bottom: 40px;
    }
    .info {
      font-size: 18px;
      line-height: 32px;
    }
  }
 
}
</style>
